import React, { useState } from "react";
import "./premiumfloatingsocial.css";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { Link } from 'react-router-dom';
import fico from './fico-logo.svg';

const PremiumFloatingSocial = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="floating-wrapper">
      <div className={`floating-menu ${open ? "active" : ""}`}>
        
        <a href="https://www.instagram.com/mrle_garage/reels/?__d=1%2F" target="_blank" rel="noreferrer" className="icon instagram">
          <svg viewBox="0 0 24 24">
            <path d="M7 2C4.2 2 2 4.2 2 7v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V7c0-2.8-2.2-5-5-5H7zm5 5a5 5 0 110 10 5 5 0 010-10zm6.5-.8a1.3 1.3 0 11-2.6 0 1.3 1.3 0 012.6 0z"/>
          </svg>
        </a>

        <a href="https://geteventlyapp.com/event/60aec1ff-c0fe-4dc3-afce-3c9f46231d2c" target="_blank" rel="noreferrer" className="icon facebook">
          <i class="fa-duotone fa-solid fa-e"></i>
        </a>

        <a href="https://www.instagram.com/auto_fico_shop/" target="_blank" rel="noreferrer" className="icon x">
          <Link className="majice" to="https://www.instagram.com/auto_fico_shop/">
              <img src={fico} className="logo" alt="logo" height="45" />
          </Link>
        </a>

      </div>

      <button
        className={`floating-btn ${open ? "rotate" : ""}`}
        onClick={() => setOpen(!open)}
      >
        +
      </button>
    </div>
  );
};

export default PremiumFloatingSocial;